import {Button} from "react-bootstrap";
import React from "react";
import {useLotto5d} from "../../store/lotto5d/Lotto5dContext";
import RowCard from "../betting/RowCard";

export default () => {
    const {
        t,
        activeSubmit = true,
        handleSubmitBetting,
        handleSubmitEnter,
        resetBet
    } = useLotto5d();

    return (
        <RowCard mainClass="lo5d-bet-btn align-items-end justify-content-center" bodyClass="betting-h">
            <div className="row align-items-start justify-content-between w-100">
                <div className="w-100">
                    <div className="d-flex justify-content-center w-100 m-auto">
                        <Button id="save"
                                 className="bg-green border-0 m-btn-bet custom-btn"
                                 disabled={!activeSubmit}
                                 onClick={() => handleSubmitBetting(false)}>
                            {t("buttons:save")}
                        </Button>
                        <Button disabled={!activeSubmit}
                                 className='m-btn-bet custom-btn'
                                 id="saveprint"
                                 onClick={() => handleSubmitBetting(true)}>
                            {t("buttons:print")}
                        </Button>
                        <Button
                            id="clear"
                            className="bg-danger border-0 m-btn-bet custom-btn"
                            onClick={resetBet}>
                            {t("buttons:clear")}
                        </Button>
                        <Button
                            className='m-btn-bet custom-btn'
                            id="ready"
                            onClick={handleSubmitEnter}>
                            {t("buttons:added")}
                        </Button>
                    </div>
                </div>
            </div>
        </RowCard>
    );
}